import { render, staticRenderFns } from "./UpdatePage.vue?vue&type=template&id=b52cf0da"
import script from "./UpdatePage.vue?vue&type=script&lang=js"
export * from "./UpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports